


import { useState } from "react";
import { useNavigate } from "react-router-dom";
 import BannerOne from "../share/component.jsx/banner";
import aboutbanner from "../assets/aboutbanner.jpg";
import PosterOne from "../share/component.jsx/posterone";

const services = [
  {
    id: 1,
    title: "Cardiac Consultation",
    description:
      "Cardiac consultation is used in patients with chest pains, shortness of breath, palpitations, hypertension, and the risk of heart disease. We provide heart cardiologists consultation services with clarity in report reviews, medicine prescriptions, and lifestyle recommendations. Earlier consultation may aid in improved heart treatment and long-term health care planning.",
    fullContent: "Cardiac consultation is essential for patients experiencing chest pains, shortness of breath, palpitations, hypertension, and those at risk of heart disease. Our experienced cardiologists provide comprehensive services including:\n\n• Clear and detailed report reviews\n• Personalized medicine prescriptions\n• Lifestyle recommendations tailored to your condition\n• Early consultation for improved treatment outcomes\n• Long-term health care planning",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" width={28} height={28}>
        <path d="M12 21s-6-4.35-6-10a6 6 0 0 1 12 0c0 5.65-6 10-6 10z" />
        <path d="M9 11l2 2 4-4" />
      </svg>
    ),
    accent: "#2acb35",
    accentLight: "#EFF6FF",
    iconBg: "#E0F2FE",
    image: require('../assets/symptoms/cardiacConsult.png'),
    tag: "Cardiology",
  },
  {
    id: 2,
    title: "Internal Medicine Consultation",
    description:
      "Our Internal Medicine consultation covers multi-system conditions and a broad spectrum of adult health conditions, including diabetes mellitus, thyroid dysfunction, dyslipidemia, hypertension and its complications, acute and chronic infections, respiratory conditions, and gastrointestinal issues with unexplained symptoms.",
    fullContent: "Our Internal Medicine consultation resembles multi-system conditions covering a broad spectrum of adult health conditions, including:\n\n• Diabetes mellitus management\n• Thyroid dysfunction and disorders\n• Dyslipidemia and cholesterol management\n• Hypertension and end-organ complications (kidneys, eyes, brain)\n• Acute and chronic infectious diseases\n• Respiratory conditions (pneumonia, COPD, asthma exacerbations)\n• Gastrointestinal complaints and liver function abnormalities\n• Unexplained fever, fatigue, or generalized weakness\n• Weight loss evaluation",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" width={28} height={28}>
        <path d="M4 6h16" />
        <path d="M4 12h16" />
        <path d="M4 18h16" />
      </svg>
    ),
    accent: "#2acb35",
    accentLight: "#ECFEFF",
    iconBg: "#CCFBF1",
    image: require('../assets/symptoms/internalMed.png'),
    tag: "Internal Medicine",
  },
  {
    id: 3,
    title: "Diagnose & Research",
    description:
      "Our diagnosis is done properly, and then we plan the treatment. Your symptoms, medical history, and test reports are carefully examined by our specialists to propose the best course of action explicitly.",
    fullContent: "Our comprehensive diagnosis and research approach includes:\n\n• Careful examination of your symptoms\n• Thorough review of medical history\n• Analysis of all test reports and findings\n• Specialist assessment and evaluation\n• Clear treatment proposals and recommendations\n• Reduction of confusion and uncertainty\n• Prompt guidance for patients\n• Assurance of appropriate treatment journey",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" width={28} height={28}>
        <path d="M21 21l-6-6" />
        <circle cx="10" cy="10" r="7" />
      </svg>
    ),
    accent: "#2acb35",
    accentLight: "#FFEDD5",
    iconBg: "#FEF3C7",
    image: require('../assets/symptoms/diagnosis.png'),
    tag: "Evaluation",
  },
  {
    id: 4,
    title: "Cutting-Edge Treatment Consultation",
    description:
      "We offer advice on specialty treatment for cardiology and internal medicine. We offer insights on transcatheter aortic valve replacement (TAVR), left atrial appendage closure (LAAC), and pulsed field ablation (PFA). We consult on innovative therapy and GLP-1 for metabolic and cardiovascular disease risk.",
    fullContent: "Our Cutting-Edge Treatment Consultation provides expert advice on the latest medical innovations:\n\n• Transcatheter Aortic Valve Replacement (TAVR)\n• Left Atrial Appendage Closure (LAAC)\n• Pulsed Field Ablation (PFA) for cardiac arrhythmias\n• GLP-1 therapy for metabolic and cardiovascular disease\n• Comprehensive explanation of treatments and associated risks\n• Discussion of benefits and treatment rationale\n• Options for utilization tailored to patient needs\n• Personalized care plans based on individual requirements",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" width={28} height={28}>
        <path d="M4 12h16" />
        <path d="M12 4v16" />
      </svg>
    ),
    accent: "#2acb35",
    accentLight: "#EEF2FF",
    iconBg: "#EDE9FE",
    image: require('../assets/symptoms/cuttingEdge.png'),
    tag: "Advanced Care",
  },
  {
    id: 5,
    title: "TCM & Rehabilitation Consultation",
    description:
      "Acute treatment isn't the end. Our team offers consultations for Traditional Chinese Medicine (TCM) and rehabilitation care. Our TCM services include acupuncture, herbal medicine, cupping, and moxibustion. Our rehabilitation includes post-surgery support and cardiac rehabilitation.",
    fullContent: "Acute treatment isn't the end. Our comprehensive TCM & Rehabilitation Consultation includes:\n\nTraditional Chinese Medicine Services:\n• Acupuncture therapy\n• Herbal medicine treatments\n• Cupping therapy\n• Moxibustion\n• Treatment for hunger pains and post-stroke muscle weakness\n• Management of persistent fatigue\n• Improved circulation\n• Sleep disorder resolution\n\nRehabilitation Services:\n• Post-surgery recovery support\n• Muscle and joint strengthening\n• Functional rehabilitation after long-term illness\n• Cardiac rehabilitation for post-surgery recovery\n• Individualized care plans based on patient condition\n• Goal-oriented recovery approach\n• Restoration of strength, function, and well-being",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" width={28} height={28}>
        <path d="M12 20c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8z" />
        <path d="M12 8v4l2 2" />
      </svg>
    ),
    accent: "#2acb35",
    accentLight: "#DCFCE7",
    iconBg: "#D1FAE5",
    image: require('../assets/symptoms/rahab.png'),
    tag: "Rehab",
  },
  {
    id: 6,
    title: "Preventive Health Checkup",
    description:
      "Preventive health checkups assist in the detection of health risks before they become severe. We specialize in examining fundamental examinations, lifestyle, family history, and health issues. Thereafter, we direct patients on diet, exercise, medication, or additional tests as necessary.",
    fullContent: "Preventive health checkups are essential for early detection and disease prevention:\n\n• Detection of health risks before they become severe\n• Fundamental health examinations and screening\n• Lifestyle assessment and analysis\n• Family history evaluation\n• Comprehensive health issue assessment\n• Personalized guidance on:\n  - Dietary recommendations\n  - Exercise programs\n  - Medication management\n  - Additional testing as needed\n• Periodic examination support\n• Promotion of a healthier and safer life",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" width={28} height={28}>
        <path d="M12 7v5l3 3" />
        <path d="M6 9a7 7 0 1 1 12 5.9" />
      </svg>
    ),
    accent: "#2acb35",
    accentLight: "#E0F2FE",
    iconBg: "#DBEAFE",
    image: require('../assets/symptoms/healthCheckup.png'),
    tag: "Preventive",
  },
];

const HeartbeatDivider = () => (
  <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "6px", margin: "8px 0 40px" }}>
    <div style={{ width: 32, height: 1.5, background: "#CBD5E1" }} />
    <svg viewBox="0 0 80 24" width={80} height={24} fill="none">
      <polyline
        points="0,12 16,12 22,4 28,20 34,4 40,20 46,12 80,12"
        stroke="#2563EB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
    <div style={{ width: 32, height: 1.5, background: "#CBD5E1" }} />
  </div>
);

const ServiceCard = ({ service, index }) => {
  const [hovered, setHovered] = useState(false);
  const [expanded, setExpanded] = useState(false);

  return (
    <>
    <style>{`
        
        *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

        @keyframes slideDown {
          from {
            opacity: 0;
            transform: translateY(-12px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .cardo-root {
          font-family: 'Hind', sans-serif;
          background: #fff;
          color: #0f172a;
          min-height: 100vh;
        }

        /* NAV */
        .cardo-nav {
          position: sticky;
          top: 0;
          z-index: 100;
          background: rgba(255,255,255,0.95);
          backdrop-filter: blur(12px);
          border-bottom: 1px solid #f1f5f9;
          padding: 0 40px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          height: 68px;
        }
        .cardo-logo {
          display: flex;
          align-items: center;
          gap: 10px;
          text-decoration: none;
        }
        .cardo-logo-icon {
          width: 38px; height: 38px;
          background: linear-gradient(135deg, #2acb35, #4dde70);
          border-radius: 10px;
          display: flex; align-items: center; justify-content: center;
          font-size: 20px;
        }
        .cardo-logo-text {
          font-family: 'Cormorant Garamond', serif;
          font-size: 20px;
          font-weight: 700;
          color: #0f172a;
          letter-spacing: -0.02em;
        }
        .cardo-logo-text span { color: #2acb35; }
        .cardo-nav-links {
          display: flex;
          gap: 32px;
          list-style: none;
        }
        .cardo-nav-links a {
          text-decoration: none;
          font-size: 14px;
          font-weight: 500;
          color: #475569;
          transition: color 0.2s;
        }
        .cardo-nav-links a:hover { color: #2acb35; }
        .cardo-nav-cta {
          background: linear-gradient(135deg, #2acb35, #4dde70);
          color: #fff;
          border: none;
          padding: 10px 22px;
          border-radius: 30px;
          font-size: 13px;
          font-weight: 700;
          cursor: pointer;
          letter-spacing: 0.04em;
          transition: opacity 0.2s, transform 0.2s;
          font-family: 'Hind', sans-serif;
        }
        .cardo-nav-cta:hover { opacity: 0.9; transform: translateY(-1px); }
        .cardo-hamburger {
          display: none;
          background: none;
          border: none;
          font-size: 24px;
          cursor: pointer;
          color: #0f172a;
        }

        /* HERO */
        .cardo-hero {
          background: linear-gradient(135deg, #0f172a 0%, #1e1b4b 60%, #3b0764 100%);
          position: relative;
          overflow: hidden;
          padding: 100px 40px 80px;
          display: flex;
          align-items: center;
          justify-content: center;
          min-height: 88vh;
        }
        .cardo-hero-bg {
          position: absolute;
          inset: 0;
          background:
            radial-gradient(ellipse 60% 60% at 80% 50%, rgba(42,203,53,0.18) 0%, transparent 70%),
            radial-gradient(ellipse 40% 40% at 15% 70%, rgba(99,102,241,0.12) 0%, transparent 60%);
          pointer-events: none;
        }
        .cardo-hero-grid-lines {
          position: absolute;
          inset: 0;
          background-image:
            linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px),
            linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px);
          background-size: 48px 48px;
          pointer-events: none;
        }
        .cardo-hero-content {
          position: relative;
          z-index: 2;
          max-width: 900px;
          text-align: center;
        }
        .cardo-hero-badge {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          background: rgba(42,203,53,0.18);
          border: 1px solid rgba(42,203,53,0.4);
          color: #65c772;
          font-size: 12px;
          font-weight: 700;
          letter-spacing: 0.1em;
          text-transform: uppercase;
          padding: 6px 16px;
          border-radius: 30px;
          margin-bottom: 28px;
        }
        .cardo-hero-badge::before { content: '●'; color: #2acb35; font-size: 8px; }
        .cardo-hero-h1 {
          font-family: 'Cormorant Garamond', Georgia, serif;
          font-size: clamp(38px, 6vw, 76px);
          font-weight: 700;
          color: #fff;
          line-height: 1.1;
          letter-spacing: -0.02em;
          margin-bottom: 24px;
        }
        .cardo-hero-h1 em {
          font-style: italic;
          background: linear-gradient(90deg, #6fdd8a, #2acb35);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }
        .cardo-hero-sub {
          font-size: clamp(15px, 2vw, 18px);
          color: rgba(255,255,255,0.7);
          max-width: 620px;
          margin: 0 auto 40px;
          line-height: 1.75;
          font-family: 'Lora', serif;
        }
        .cardo-hero-btns {
          display: flex;
          gap: 16px;
          justify-content: center;
          flex-wrap: wrap;
        }
        .btn-primary {
          background: linear-gradient(135deg, #2acb35, #4dde70);
          color: #fff;
          border: none;
          padding: 15px 34px;
          border-radius: 40px;
          font-size: 14px;
          font-weight: 700;
          cursor: pointer;
          letter-spacing: 0.05em;
          transition: all 0.25s;
          font-family: 'Hind', sans-serif;
          box-shadow: 0 8px 24px rgba(42,203,53,0.4);
        }
        .btn-primary:hover { transform: translateY(-2px); box-shadow: 0 12px 32px rgba(42,203,53,0.5); }
        .btn-outline {
          background: rgba(255,255,255,0.08);
          color: #fff;
          border: 1.5px solid rgba(255,255,255,0.25);
          padding: 15px 34px;
          border-radius: 40px;
          font-size: 14px;
          font-weight: 600;
          cursor: pointer;
          letter-spacing: 0.04em;
          transition: all 0.25s;
          font-family: 'Hind', sans-serif;
          backdrop-filter: blur(4px);
        }
        .btn-outline:hover { background: rgba(255,255,255,0.15); border-color: rgba(255,255,255,0.45); }

        /* STATS BAR */
        .cardo-stats {
          background: linear-gradient(135deg, #123b21 0%, #1a5a2f 100%);
          padding: 36px 40px;
          display: flex;
          justify-content: center;
          gap: 0;
          flex-wrap: wrap;
        }
        .cardo-stat {
          flex: 1;
          min-width: 140px;
          text-align: center;
          padding: 12px 20px;
          position: relative;
        }
        .cardo-stat:not(:last-child)::after {
          content: '';
          position: absolute;
          right: 0; top: 20%; height: 60%;
          width: 1px;
          background: rgba(255,255,255,0.25);
        }
        .cardo-stat-val {
          font-family: 'Cormorant Garamond', serif;
          font-size: clamp(28px, 4vw, 42px);
          font-weight: 700;
          color: #fff;
          line-height: 1;
          display: block;
        }
        .cardo-stat-lbl {
          font-size: 12px;
          font-weight: 600;
          color: rgba(255,255,255,0.75);
          letter-spacing: 0.08em;
          text-transform: uppercase;
          margin-top: 6px;
          display: block;
        }

        /* SECTIONS */
        .cardo-section {
          padding: 90px 40px;
          max-width: 1240px;
          margin: 0 auto;
        }
        .cardo-section-label {
          font-size: 11px;
          font-weight: 700;
          color: #2acb35;
          letter-spacing: 0.18em;
          text-transform: uppercase;
          margin-bottom: 12px;
        }
        .cardo-section-h2 {
          font-family: 'Cormorant Garamond', Georgia, serif;
          font-size: clamp(28px, 4vw, 48px);
          font-weight: 700;
          color: #0f172a;
          line-height: 1.15;
          letter-spacing: -0.02em;
          margin-bottom: 16px;
        }
        .cardo-section-desc {
          font-size: 16px;
          color: #64748b;
          max-width: 560px;
          line-height: 1.75;
          font-family: 'Lora', serif;
          margin-bottom: 56px;
        }
        .cardo-services-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 24px;
        }

        /* WHY SECTION */
        .cardo-why {
          background: #f8fafc;
          padding: 90px 40px;
        }
        .cardo-why-inner {
          max-width: 1240px;
          margin: 0 auto;
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 80px;
          align-items: center;
        }
        .cardo-why-cards {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 20px;
        }
        .cardo-why-card {
          background: #fff;
          border-radius: 16px;
          padding: 24px;
          border: 1.5px solid #f1f5f9;
          transition: border-color 0.25s, box-shadow 0.25s;
        }
        .cardo-why-card:hover {
          border-color: rgba(42,203,53,0.3);
          box-shadow: 0 8px 32px rgba(42,203,53,0.1);
        }
        .cardo-why-card-icon {
          font-size: 28px;
          margin-bottom: 12px;
          display: block;
        }
        .cardo-why-card h4 {
          font-family: 'Cormorant Garamond', serif;
          font-size: 17px;
          font-weight: 700;
          color: #0f172a;
          margin-bottom: 8px;
        }
        .cardo-why-card p {
          font-size: 13px;
          color: #64748b;
          line-height: 1.7;
          font-family: 'Lora', serif;
        }

        /* CTA */
        .cardo-cta {
          background: linear-gradient(135deg, #0f2d1a 0%, #192f1e 100%);
          padding: 90px 40px;
          text-align: center;
          position: relative;
          overflow: hidden;
        }
        .cardo-cta::before {
          content: '';
          position: absolute;
          inset: 0;
          background: radial-gradient(ellipse 50% 80% at 50% 100%, rgba(42,203,53,0.2) 0%, transparent 70%);
          pointer-events: none;
        }
        .cardo-cta h2 {
          font-family: 'Cormorant Garamond', serif;
          font-size: clamp(28px, 4vw, 52px);
          font-weight: 700;
          color: #fff;
          letter-spacing: -0.02em;
          margin-bottom: 16px;
          position: relative;
        }
        .cardo-cta p {
          font-size: 16px;
          color: rgba(255,255,255,0.65);
          max-width: 500px;
          margin: 0 auto 36px;
          font-family: 'Lora', serif;
          line-height: 1.7;
          position: relative;
        }

        /* FOOTER */
        .cardo-footer {
          background: #0f172a;
          border-top: 1px solid rgba(255,255,255,0.06);
          padding: 24px 40px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-wrap: wrap;
          gap: 12px;
        }
        .cardo-footer p {
          font-size: 13px;
          color: rgba(255,255,255,0.4);
        }
        .cardo-footer-kw {
          display: flex;
          gap: 10px;
          flex-wrap: wrap;
        }
        .cardo-footer-kw span {
          font-size: 11px;
          color: rgba(42,203,53,0.8);
          background: rgba(42,203,53,0.1);
          padding: 3px 10px;
          border-radius: 20px;
          letter-spacing: 0.04em;
        }

        /* RESPONSIVE */
        @media (max-width: 900px) {
          .cardo-nav-links, .cardo-nav-cta { display: none; }
          .cardo-hamburger { display: block; }
          .cardo-services-grid { grid-template-columns: repeat(2, 1fr); }
          .cardo-why-inner { grid-template-columns: 1fr; gap: 40px; }
        }
        @media (max-width: 600px) {
          .cardo-nav { padding: 0 20px; }
          .cardo-hero { padding: 80px 20px 60px; min-height: 70vh; }
          .cardo-section { padding: 60px 20px; }
          .cardo-why { padding: 60px 20px; }
          .cardo-why-cards { grid-template-columns: 1fr; }
          .cardo-services-grid { grid-template-columns: 1fr; }
          .cardo-stats { padding: 28px 20px; }
          .cardo-stat:not(:last-child)::after { display: none; }
          .cardo-cta { padding: 60px 20px; }
          .cardo-footer { padding: 20px; flex-direction: column; align-items: flex-start; }
        }
      `}</style>

      <div
        onClick={() => setExpanded(!expanded)}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      
        style={{
          background: "#fff",
          borderRadius: "16px",
          overflow: "hidden",
          boxShadow: hovered
            ? "0 20px 48px rgba(37,99,235,0.13), 0 4px 16px rgba(0,0,0,0.07)"
            : "0 2px 16px rgba(0,0,0,0.06)",
          transition: "box-shadow 0.3s ease, transform 0.3s ease",
          transform: hovered ? "translateY(-6px)" : "translateY(0)",
          display: "flex",
          flexDirection: "column",
          animationDelay: `${index * 0.12}s`,
          cursor: "pointer",
        }}
      >
        {/* Image */}
        <div style={{ position: "relative", width: "100%", paddingTop: "64%", overflow: "hidden" }}>
          <img
            src={service.image}
            alt={service.title}
            style={{
              position: "absolute",
              inset: 0,
              width: "100%",
              height: "100%",
              objectFit: "cover",
              transition: "transform 0.5s ease",
              transform: hovered ? "scale(1.06)" : "scale(1)",
            }}
          />
          {/* Tag */}
          <span
            style={{
              position: "absolute",
              top: 14,
              left: 14,
              background: "rgba(255,255,255,0.88)",
              backdropFilter: "blur(6px)",
              color: service.accent,
              fontSize: "11px",
              fontWeight: 700,
              letterSpacing: "0.08em",
              textTransform: "uppercase",
              padding: "4px 10px",
              borderRadius: "20px",
              border: `1px solid ${service.accent}30`,
            }}
          >
            {service.tag}
          </span>
        </div>

        {/* Content */}
        <div style={{ padding: "36px 28px 28px", flex: 1, display: "flex", flexDirection: "column" }}>
          <h3
            style={{
              margin: "0 0 12px",
              fontSize: "20px",
              fontWeight: 700,
              color: service.btnVariant === "filled" ? service.accent : "#1E293B",
              fontFamily: "'Poppins', sans-serif",
              letterSpacing: "-0.01em",
            }}
          >
            {service.title}
          </h3>
          <p
            style={{
              margin: "0 0 16px",
              fontSize: "14.5px",
              lineHeight: 1.7,
              color: "#64748B",
              fontFamily: "'Open Sans', sans-serif",
              flex: 1,
            }}
          >
            {service.description}
          </p>
          <button
            style={{
              background: service.accent,
              color: "#fff",
              border: "none",
              padding: "8px 16px",
              borderRadius: "6px",
              fontSize: "13px",
              fontWeight: 600,
              cursor: "pointer",
              transition: "opacity 0.3s ease",
              opacity: hovered ? 1 : 0.9,
            }}
            onMouseEnter={(e) => e.target.style.opacity = "1"}
            onMouseLeave={(e) => e.target.style.opacity = "0.9"}
          >
            {expanded ? "Show Less" : "Read More"}
          </button>
        </div>
      </div>

      {/* Expanded Detail Section */}
      {expanded && (
        <div
          style={{
            background: "#fff",
            borderRadius: "16px",
            padding: "28px",
            marginTop: "16px",
            boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
            gridColumn: "1 / -1",
            animation: "slideDown 0.3s ease",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              marginBottom: "20px",
              color: service.accent,
            }}
          >
            <div style={{ width: 4, height: 24, background: service.accent, borderRadius: "2px" }} />
            <h3 style={{ margin: 0, fontSize: "22px", fontWeight: 700, fontFamily: "'Poppins', sans-serif" }}>
              {service.title}
            </h3>
          </div>
          <p
            style={{
              whiteSpace: "pre-wrap",
              fontSize: "15px",
              lineHeight: 1.8,
              color: "#475569",
              fontFamily: "'Open Sans', sans-serif",
              margin: 0,
            }}
          >
            {service.fullContent}
          </p>
        </div>
      )}
    </>
  );
};

export default function ClinicalConsultations() {
  const navigate = useNavigate();
  return (
    <>
      <style>{`
       
        * { box-sizing: border-box; }

        @keyframes slideDown {
          from {
            opacity: 0;
            transform: translateY(-12px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .med-section {
          background: #F8FAFC;
          min-height: 100vh;
          padding: 64px 24px 80px;
          font-family: "Open Sans", sans-serif;
        }

        .med-section,
        .med-section * {
          font-family: "Open Sans", sans-serif !important;
        }

        .med-section h1,
        .med-section h2,
        .med-section h3,
        .med-section h4,
        .med-section h5,
        .med-section h6,
        .service-cta h2 {
          font-family: "Poppins", sans-serif !important;
        }

        .med-tagline {
          text-align: left;
          font-family: "Poppins", sans-serif;
          font-size: 14px;
          color: #2acb35;
          letter-spacing: 0.06em;
          font-weight: 300;
          margin: 0 0 12px;
          max-width: none;
        }

        .med-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 28px;
          max-width: 1200px;
          margin: 0 auto;
        }

        @media (max-width: 900px) {
          .med-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }

        @media (max-width: 580px) {
          .med-grid {
            grid-template-columns: 1fr;
          }
          .med-tagline {
            font-size: 15px;
            letter-spacing: 0.02em;
          }
          .med-section {
            padding: 40px 16px 60px;
          }
        }
      `}</style>
       <BannerOne
          img={require('../assets/symptoms/clinicalBanner.png')}
          title={"Clinical Consultations"}
          subtitle={""}
        />

      <div className="acc-root">
        
       

        <section className="cardo-section">
          <p className="cardo-section-label">Get Reliable Clinical Consultation on Your Heart and General Health Requirements</p>
          <h2 className="cardo-section-h2">Our specialists will help you with<br /> straightforward guidance, <br /> cautious diagnosis, <br/> and individual care.</h2>
          <p className="cardo-section-desc">
            Our medical specialists care about you & your family's health. Your health deserves the proper attention at the appropriate moment. Our clinical consultation service enables patients to learn about symptoms, reports, and treatment options using easy language. When you need to find the best cardiac hospital near you, our team helps to evaluate your situation thoroughly and provide you with patient-centered care.
          </p>
          <div className="med-grid">
          {services.map((service, i) => (
            <ServiceCard key={service.id} service={service} index={i} />
          ))}
        </div>
        </section>

       <section className="service-cta">
          <div className="service-container">
            <h2>Ready to Take Care of Your Health?</h2>
            <p>Call us today to talk about your cardiac or general health consultation needs. We will discuss your symptoms, your reports, and the stage your condition is in, and help you receive care in a clinically relevant and practical manner.</p>
            <div className="service-btns" style={{ justifyContent: 'center' }}>
              <button className="service-btn-primary" onClick={() => navigate('/consultations')}>Book Your Consultation</button>
            </div>
          </div>
        </section>
       </div>
    </>
  );
}